export default __webpack_public_path__ + "static/media/clio-rs-colour-1.d592caa9.jpg";